const state = {
  urlQuery: {},
};

const mutations = {
  INIT_URL_QUERY(state){
    const querys = window.location.search.substring(1).split('&');
    const urlQuery = querys.reduce((r, v) => {
      const pair = v.split('=');
      r[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      return r;
    }, {});
    state.urlQuery = urlQuery;
  },
};

const actions = {
  initUrlQuery({ commit }){
    commit('INIT_URL_QUERY');
  },
};

const getters = {
  urlQuery: (state) => (key) => state.urlQuery[key],
};

export default {
  state,
  mutations,
  actions,
  getters,
};
